module.exports = __webpack_public_path__ + "img/4549c4c.png";